import React, { useEffect, useState } from "react"
import Header from "../../../../components/layout/landing/desktop/app-bar"
import Head from "next/head"
import {
  Container,
  Grid,
  InputAdornment,
  TextField,
  alpha,
  useTheme,
  Typography,
  Button,
  Box,
  ToggleButtonGroup,
  ToggleButton
} from "@mui/material"
import AppStickSection from "../../../../components/AppStickSection"
import { CardPos } from "iconsax-react"
import { useForm } from "react-hook-form"
import ValidationHelperText from "../../../../components/common/validation-helper-text"
import { useRouter } from "next/router"
import Payment from "../payment"

function MobileDirectPayment({ paymentUrl }) {
  const theme = useTheme()
  const router = useRouter()
  const [paymentStatus, setPaymentStatus] = useState("1")
  let profileData
  if (typeof window !== "undefined") {
    profileData = localStorage.getItem("user")
  }
  useEffect(() => {
    if (profileData && !parseInt(paymentUrl)) {
      setPaymentStatus("2")
    }
  }, [profileData, paymentUrl])

  const handleChangeReqType = (event, newAlignment) => {
    setPaymentStatus(newAlignment)
  }

  const {
    control,
    handleSubmit,
    register,
    reset,
    getValues,
    setValue,
    formState: { errors }
  } = useForm()
  useEffect(() => {
    if (paymentUrl) setValue("paymentId", paymentUrl)
  }, [])

  const onSubmit = () => {
    router.push(`installment/${getValues("paymentId")}`)
  }
  return (
    <>
      <Header isOtherPages={true} />
      <Head>
        <title>پرداخت مستقیم اقساط</title>
      </Head>
      <div style={{ padding: "0.5rem" }}>
        <Container
          sx={{
            padding: "1rem",
            bgcolor: "#ebebeb",
            justifyContent: "center",
            borderRadius: "1rem"
          }}
          id='acceptors'
        >
          {profileData && Object.keys(profileData).length > 0 && (
            <Box width={"100%"} textAlign={"center"} marginTop={"2rem"}>
              <Grid container spacing={2} justifyContent={"center"}>
                <Grid item md={12} xs={12}>
                  <ToggleButtonGroup
                    defaultValue={"1"}
                    color='primary'
                    value={paymentStatus}
                    exclusive
                    onChange={handleChangeReqType}
                    aria-label='Platform'
                  >
                    <ToggleButton value='2'>پرداخت قسط خودم</ToggleButton>
                    <ToggleButton value='1'>پرداخت با شماره تسهیلات</ToggleButton>
                  </ToggleButtonGroup>
                </Grid>
              </Grid>
            </Box>
          )}
          {paymentStatus === "1" ? (
            <form onSubmit={handleSubmit(onSubmit)}>
              <AppStickSection title={"پرداخت مستقیم اقساط"} />
              <Typography variant='body1' color='initial'>
                کاربر گرامی لطفا شماره تسهیلات مورد نظر خود را وارد کرده و جهت پرداخت اقساط اقدام نمایید
              </Typography>
              <Grid container spacing={2} item xs={12} height={"50vh"} justifyContent={"center"}>
                <Grid xs={12} md={6} mt={4} ml={1}>
                  <TextField
                    label='شماره تسهیلات'
                    fullWidth
                    inputProps={{ maxLength: 50 }}
                    name='paymentId'
                    InputLabelProps={
                      paymentUrl.length
                        ? {
                            shrink: true
                          }
                        : {
                            shrink: false
                          }
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='start'>
                          <CardPos size={20} color={theme.palette.primary.dark} />
                        </InputAdornment>
                      )
                    }}
                    sx={{
                      caretColor: theme.palette.secondary.main,
                      "& .MuiInputBase-root": {
                        borderRadius: "8px",
                        backgroundColor: alpha(theme.palette.grey[200], 0.5)
                      }
                    }}
                    {...register("paymentId", {
                      required: {
                        value: true,
                        message: "شماره تسهیلات الزامی است"
                      }
                    })}
                  />
                  <ValidationHelperText error={!!errors?.paymentId} helperText={errors?.paymentId?.message} />
                </Grid>
                <Grid md={12} xs={12} ml={1}>
                  <Button
                    type='submit'
                    variant='contained'
                    size='large'
                    sx={{ borderRadius: "8px" }}
                    disableElevation
                    fullWidth
                  >
                    پرداخت قسط
                  </Button>
                </Grid>
              </Grid>
            </form>
          ) : (
            <Payment />
          )}
        </Container>
      </div>
    </>
  )
}

export default MobileDirectPayment
